<template>
    <div class="card shadow my-3 bg-white rounded d-none d-lg-block">
        <div class="d-flex p-5 justify-content-center align-items-center map_background">
            <img :src="`/img/cars/` + this.balise.icon">
        </div>
        <div class="card-footer bg-white py-3 text-center">
            <RouterLink :to="'/home/' + this.balise.id">Voir sur la carte</RouterLink>
        </div>
    </div>
</template>

<script>
export default {
    props: ['balise'],
}
</script>